import React, { useState, useEffect, useCallback } from 'react';
import './Testimonials.css';

const Testimonials = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    { quote: "MTC School has been instrumental in shaping my child's academic journey. The teachers are dedicated, and the holistic approach to education is remarkable.", name: "Sarah Johnson", role: "Parent of Grade 8 Student", avatar: "👩" },
    { quote: "The best decision we made was enrolling our daughter at MTC School. She has developed not just academically but also in terms of confidence and character.", name: "Michael Chen", role: "Parent of Grade 10 Student", avatar: "👨" },
    { quote: "As an alumnus, I can confidently say that MTC School prepared me well for university and beyond. The values instilled here stay with you for life.", name: "Priya Sharma", role: "Alumni, Class of 2020", avatar: "👩‍🎓" },
    { quote: "The extracurricular activities at MTC School are exceptional. My son discovered his passion for robotics here, and now he's pursuing engineering.", name: "David Williams", role: "Parent of Grade 12 Student", avatar: "👨‍💼" },
    { quote: "MTC School provides a safe and nurturing environment. The faculty genuinely cares about each student's growth and well-being.", name: "Emily Rodriguez", role: "Parent of Grade 5 Student", avatar: "👩‍💼" },
  ];

  const next = useCallback(() => {
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  }, [testimonials.length]);

  const prev = () => {
    setActiveIndex((p) => (p - 1 + testimonials.length) % testimonials.length);
  };

  useEffect(() => {
    const timer = setInterval(next, 6000);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <section id="testimonials" className="testimonials">
      <div className="container">
        <div className="section-title">
          <h2>What Parents Say</h2>
          <p>Hear from our community about their experience with MTC School</p>
        </div>
        <div className="testimonials-container">
          <button className="nav-btn prev-btn" onClick={prev} aria-label="Previous">{'\u2190'}</button>
          <div className="testimonials-wrapper">
            {testimonials.map((t, index) => (
              <div key={index} className={`testimonial-card ${index === activeIndex ? 'active' : ''}`}>
                <div className="quote-icon">{'\u201C'}</div>
                <p className="testimonial-quote">{t.quote}</p>
                <div className="testimonial-author">
                  <span className="author-avatar">{t.avatar}</span>
                  <div className="author-info">
                    <h4>{t.name}</h4>
                    <span>{t.role}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <button className="nav-btn next-btn" onClick={next} aria-label="Next">{'\u2192'}</button>
        </div>
        <div className="testimonial-dots">
          {testimonials.map((_, index) => (
            <button key={index} className={`dot ${index === activeIndex ? 'active' : ''}`} onClick={() => setActiveIndex(index)} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
